export const formatAddress = address => {
  const addresses = [address.postcode, address.organisation, address.property, address.street, address.county, address.locality, address.town];
  return addresses.filter(item => !!item).join(", ").trim();
};